import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenericService, ErrorConfig } from './generic.service';
import { UsersService } from './users.service';
import { ServerResponse } from '../models/ServerResponse';
import { Observable } from 'rxjs';
import { IGroupingElectricityPrice, IGroupingPrice, IPrice } from '../models/Price';
import { FilterOperator, ISAPI, ISFilterAPI, ISPagination, MVFilter, MVListingConfigs, MVOrdering } from 'is-lib';
import { IElectricityMetersTotalConsumptionPT, INaturalGasMetersTotalConsumption } from '../models/Consumptions';
import { IElectricityOmipPricesPT, INaturalGasOmipPricesPT } from '../models/OmipPrice';

@Injectable({
    providedIn: 'root'
})
export class PriceService {
    
constructor(private _httpService: GenericService, private _user: UsersService) { }

    getPrice(groupingPriceId: string, callLoader: boolean = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<IGroupingPrice>> {
        return this._httpService.get(`${environment.apiUrl}GroupingPrices/${groupingPriceId}`, callLoader, undefined, undefined, errorConfig);
    }

    getPricesByGrouping(groupingId: string, body?: ISAPI, callLoader: boolean = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<IPrice[]>> {
        if (!body) {
            body = new ISAPI( [], new ISPagination(100, 0) );
        }

        return this._httpService.post(`${environment.apiUrl}Groupings/${groupingId}/Prices`, body, undefined, callLoader, undefined, errorConfig);
    }

    getElectricityOMIPPrices(body?: ISAPI, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any[]>> {
        if (!body) {
            body = new ISAPI( [], new ISPagination(100, 0) );
        }

        return this._httpService.post(`${environment.apiUrl}OmipPrices/${this._user.userCountryCode}/Electricity/Get`, body, undefined, undefined, undefined, errorConfig);
    }

    getNaturalGasOMIPPrices(body?: ISAPI, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any[]>> {
        if (!body) {
            body = new ISAPI( [], new ISPagination(100, 0) );
        }

        return this._httpService.post(`${environment.apiUrl}OmipPrices/${this._user.userCountryCode}/NaturalGas/Get`, body, undefined, undefined, undefined, errorConfig);
    }

    getElectricityOMIPPrice(priceId: string, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<IElectricityOmipPricesPT>> {
        return this._httpService.get(`${environment.apiUrl}OmipPrices/${this._user.userCountryCode}/Electricity/${priceId}`, undefined, undefined, undefined, errorConfig);
    }

    getNaturalGasOMIPPrice(priceId: string, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<INaturalGasOmipPricesPT>> {
        return this._httpService.get(`${environment.apiUrl}OmipPrices/${this._user.userCountryCode}/NaturalGas/${priceId}`, undefined, undefined, undefined, errorConfig);
    }

    getElectricityGroupingPriceTotalConsumption(groupingPriceId: string, body?: ISAPI, callLoader: boolean = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<IElectricityMetersTotalConsumptionPT[]>> {
        if (!body) {
            body = new ISAPI( [], new ISPagination(100, 0) );
        }

        return this._httpService.post(`${environment.apiUrl}GroupingPrices/${groupingPriceId}/${this._user.userCountryCode}/ElectricityGroupings/TotalConsumptions`, body, undefined, callLoader, undefined, errorConfig);
    }

    getNaturalGasGroupingPriceTotalConsumption(groupingPriceId: string, body?: ISAPI, callLoader: boolean = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<INaturalGasMetersTotalConsumption[]>> {
        if (!body) {
            body = new ISAPI( [], new ISPagination(100, 0) );
        }

        return this._httpService.post(`${environment.apiUrl}GroupingPrices/${groupingPriceId}/${this._user.userCountryCode}/NaturalGasGroupings/TotalConsumptions`, body, undefined, callLoader, undefined, errorConfig);
    }

    getGroupingPriceElectricityGroupings(groupingPriceId: string, callLoader: boolean = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any[]>> {
        return this._httpService.get(`${environment.apiUrl}GroupingPrices/${groupingPriceId}/${this._user.userCountryCode}/ElectricityGroupings`, callLoader, undefined, undefined, errorConfig);
    }

    getGroupingPriceNaturalGasGroupings(groupingPriceId: string, callLoader: boolean = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any[]>> {
        return this._httpService.get(`${environment.apiUrl}GroupingPrices/${groupingPriceId}/${this._user.userCountryCode}/NaturalGasGroupings`, callLoader, undefined, undefined, errorConfig);
    }

    getElectricityPricesForPortal(body?: any, callLoader: boolean = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any[]>> {
        return this._httpService.post(`${environment.apiUrl}ClientPortalUsers/${this._user.userCountryCode}/ElectricityPrices/Get`, body, undefined, callLoader, undefined, errorConfig);
    }

    // getNaturalGasPricesFromPricePeriod( pricePeriodId: string, body?: ISAPI, callLoader: boolean = true): Observable<ServerResponse<any[]>> {
    //     if (!body) {
    //         body = new ISAPI( [], new ISPagination(100, 0) );
    //     }

    //     return this._httpService.post(`${environment.apiUrl}PricePeriods/${pricePeriodId}/${this._user.userCountryCode}/NaturalGasPrices/EnergyFixedPrices`, body, undefined, callLoader);
    // }
}